import { render, staticRenderFns } from "./PrescriptionsSummary.vue?vue&type=template&id=12d2c39a&scoped=true"
import script from "./PrescriptionsSummary.vue?vue&type=script&lang=js"
export * from "./PrescriptionsSummary.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionsSummary.vue?vue&type=style&index=0&id=12d2c39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2c39a",
  null
  
)

export default component.exports